import { MAIN_COLOR } from '@/constant/index.js'
import { getItem } from '@/utils/storage.js'
import { generateColors } from '@/utils/theme.js'

const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  hasUserInfo: state => { return JSON.stringify(state.user.userInfo) !== '{}' },
  cssVar: (state) => {
    return {
      ...state.theme.variables, // vuex响应式对象，只有触发他的属性变化，他的值才会变化
      ...generateColors(getItem(MAIN_COLOR))
    }
  },
  sidebarOpened: state => state.app.sidebarOpened,
  language: state => state.app.language,
  mainColor: state => state.theme.mainColor,
  tagsViewList: state => state.app.tagsViewList
}
export default getters
